<template>
  <div class="p-d-inline-flex p-jc-center p-m-auto">
    <login/>
  </div>
</template>

<script>
import login from '@/components/login'
export default {
  name: 'loginPage',
  components: {
    login
  }
};
</script>